import {dispatchCrezuEvent, GetURLParameter} from '../components/helpers'
import { renderSimpleInput } from './simpleInput'
import { renderInputSlider } from './inputSlider'
import { renderEmailRepeat } from './emailRepeat'
import { renderRadioInput } from './radioInput'
import { renderConfirmEmailInput } from './confirmEmailInput'
import { renderPrestamer } from './prestamer'
import { renderMoneyman } from './moneyman'
import { renderInstantor } from './instantor'
import { renderPaylands } from './paylands'
import { renderUnnax } from './unnax'
import { renderSelect } from './select'
import { renderIBANInput } from './ibanInput'

import { initIBANHandler, initLoanSumSlider, radioHandlers, emailHandlers, phoneHandlers, dateHandlers, otherHandlers } from './handlers/handlers'

let lastValues = {}

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === "-") {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
    return result * sortOrder
  }
}

function makeInputNumeric(params) {
  let isESorMX = ['1','2'].indexOf($('[name=country]').val()) > -1
  let field = params[0]
  let pattern = params[1] || '^[0-9]+$'
  let addExp = true
  lastValues[field] = ''
  let selector = $(`[name=${field}]`)
  selector.keydown(function (e) {
    lastValues[field] = selector.val()
    return true
  }).on('input', function (e) {
    let el = e.target
    let newValue = el.value
    let regex = new RegExp(pattern)
    if (field === 'income_day') addExp = newValue.length <= 2
    if (field === 'bank_account_number') addExp = newValue.length <= 18
    if (field === 'income_amount' && isESorMX) addExp = +newValue < 100000
    if (regex.test(newValue) && addExp) {
      return true
    } else if (newValue == '') {
      return true
    }
    selector.val(lastValues[field])
  })
}

function makeFieldsFromObject(country) {
  let cont = $('.formcontent')
  cont.html('')
  if (fields_json) {
    // override sum and days limits
    try {
      let overMinSum = GetURLParameter('override_min_sum') || window.override_min_sum
      let overMaxSum = GetURLParameter('override_max_sum') || window.override_max_sum
      let overStepSum = GetURLParameter('override_step_sum') || window.override_step_sum
      if (overMinSum) fields_json.params.loan_sum.min = overMinSum
      if (overMaxSum) fields_json.params.loan_sum.max = overMaxSum
      if (overStepSum) fields_json.params.loan_sum.step = overStepSum
      if (GetURLParameter('override_min_period')) fields_json.params.loan_period.min = GetURLParameter('override_min_period')
      if (GetURLParameter('override_max_period')) fields_json.params.loan_period.max = GetURLParameter('override_max_period')
    } catch (e) {
      console.log(e)
    }

    let sorted_fields_array = fields_json.main_fields.sort(dynamicSort('order'));
    let email_repeat = function () {
      if (country.is_MX) {
        let field_html = ''
        field_html += renderEmailRepeat(country)
        cont.append(field_html)
      }
    }

    let provider = $("[name=provider]").val()

    $.each(sorted_fields_array, function (i, field) {
      window.validate_rules[i] = {
        'field_name': field.name,
        'reg': field.reg
      }
      // change ZIP type for MX domains
      if (field.name == "zip") {
        if (country.is_MX) {
          field.type = 'tel'
          field.label = 'Código postal'
        }
      }
      let field_html = ''
      if (field.type === 'radio') {
        field_html += renderRadioInput(country, field)
      } else if (field.name === 'bank_account_number') {
        field_html += renderIBANInput(country, field, provider)
      } else if (field.name === 'confirm_email') {
        field_html += renderConfirmEmailInput(country, field)
      } else if (field.type === 'new-select') {
        field_html += renderSelect(country, field)
        cont.append(field_html);
        $('.insert-' + field.name).append(createSelect(field));
        field_html = ''
      } else if (field.type === 'prestamer') {
        field_html += renderPrestamer()
      } else if (field.type === 'instantor') {
        field_html += renderInstantor()
      } else if (field.type === 'unnax') {
        field_html += renderUnnax()
      } else if (field.type === 'paylands') {
        field_html += renderPaylands(country, field)
      } else if (field.type === 'moneyman') {
        field_html += renderMoneyman()
      } else if (field.type === 'only4GF') {
        // field for game flow only, don't render it
      } else {
        if (field.name === "loan_sum") {
          field_html += renderInputSlider(country, field)
        } else {
          field_html += renderSimpleInput(country, field, provider)
        }
      }
      cont.append(field_html);
      if (field.name === 'email') {
        email_repeat()
      }
    });

    // scroll to h1 onload
    $('html, body').animate({scrollTop: ($('h1').offset()) ? $('h1').offset().top : 0}, 0);

    ['zip', 'city', 'province', 'house', 'street'].map(x => $(`[name=${x}]`).attr('autocomplete', 'new-password').attr('autocapitalize', 'false'));

    // make fields numeric input only
    [
      ['dependants'],
      ['other_loans_amount'],
      ['confirm'],
      ['income_day'],
      ['income_amount'],
      ['id_number', '^[a-zA-Zа-яА-Я0-9]+$']
    ].map(x => makeInputNumeric(x))
    if (country.is_MX) makeInputNumeric(['bank_account_number'])

    $('#agreement').prop('checked', false)
    $('#agreement_2').prop('checked', false)

    if (provider === '5') {
      $('#agreement').prop('checked', true)
      $('#agreement').closest('.ui-checkbox-directive').find('label').addClass('ui-checkbox_checked')
    }

    // hide checkboxes
    if (GetURLParameter('agreements')) {
      if (GetURLParameter('agreements') === 'false' || GetURLParameter('agreements') === false) {
        $('.app-form-action-agreement').addClass('hidden')
        $('#additional-text-collapsible').addClass('hidden')
        $('#agreement').prop('checked', true).closest('.ui-checkbox-directive').find('label').addClass('ui-checkbox_checked')
        $('#agreement_2').prop('checked', true).closest('.ui-checkbox-directive').find('label').addClass('ui-checkbox_checked')
      }
    }

    $('#expand_CLABE_info').click(function () {
      if ($('#hidden_CLABE_info').hasClass('hidden')) {
        $('#hidden_CLABE_info').removeClass('hidden')
        $('#arrow_CLABE').css('transform', 'rotate(225deg)')
      } else {
        $('#hidden_CLABE_info').addClass('hidden')
        $('#arrow_CLABE').css('transform', 'rotate(45deg)')
      }
    })

    // init handlers block
    initIBANHandler(country)
    initLoanSumSlider()
    radioHandlers()
    emailHandlers()
    phoneHandlers()
    dateHandlers()
    otherHandlers()

    // add reCaptcha for few ES & MX domains
    if (['localhost', 'crezu.es', 'crezu.mx', 'andacredito.es', 'andacredito.mx', 'pezetita.com', 'pezetita.mx'].indexOf(window.location.hostname) > -1) {
      $.getScript('https://www.google.com/recaptcha/api.js?render=6LcqgK4UAAAAAO53lS01cuVjnkpuu4erVgDwrZIV')
    }
    // check if user is authorised and hide loader
    // authAutocomplete - simple-auth with email and year of birth
    // auth_token - JWT. We send auth request to backend and than hide loader
    if ((localStorage.getItem("authAutocomplete") || localStorage.getItem("auth_token"))) {
      setTimeout(function () {
        if ($('#loader')[0]) {
          $('#loader').remove();
          dispatchCrezuEvent('formLoaded')
          console.error('loader removed by timeout')
        } else {
          console.log('loader ok')
        }
      }, 5000)
    } else {
      $('#loader').remove()
      dispatchCrezuEvent('formLoaded')
    }
  }
}

function setUpDeviders(fields) {
  $('.ui-form__row_title').remove()
  let index = 0
  for (let divider in fields_json.params.dividers_data) {
    $.each(fields_json.params.dividers_data[divider], function (i, field) {
      if (fields.indexOf(field) > -1) {
        let text = fields_json.params.dividers[index]
        let hint = ''
        let field_title_html = `<div class="ui-form__row ui-form__row_title app-form-step__title ${divider}-divider"><div class="ui-form__field ui-form__field_title"><h3 class="ui-title ui-title_form ui-title_size_s app-form-step__title">${text}</h3>${hint}</div></div>`;
        $('[name=' + field + ']').closest('.ui-form__row').before(field_title_html)
        return false
      }
    })
    index += 1
  }
}

export {makeFieldsFromObject, setUpDeviders}
